(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Pvlog', Pvlog);

    Pvlog.$inject = ['$resource', 'DateUtils'];

    function Pvlog ($resource, DateUtils) {
        var resourceUrl =  'api/pvlogs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
